import React from 'react';

const DashboardHeader = ({ activeTab }) => {
    const getTitle = () => {
        switch (activeTab) {
            case 'nira': return 'NIRA Integration';
            case 'stanbic': return 'Stanbic Bank Integration';
            case 'stanchart': return 'Standard Chartered Bank Integration';
            case 'oauth-clients': return 'OAuth Clients Management';
            default: return 'Dashboard';
        }
    };

    const getDescription = () => {
        switch (activeTab) {
            case 'nira': return 'Manage NIRA identity verification services';
            case 'stanbic': return 'Configure and monitor Stanbic Bank payment integrations';
            case 'stanchart': return 'Configure and monitor Standard Chartered Bank payment integrations';
            case 'oauth-clients': return 'Manage OAuth client applications and credentials';
            default: return 'System overview and recent activity';
        }
    };

    return (
        <div className="dashboard-overview">
            <h1>{getTitle()}</h1>
            <p className="header-description">{getDescription()}</p>
        </div>
    );
};

export default DashboardHeader;